import axios from "axios";
import { Base_URL } from "../url";

export const saveTaxCategory = async (taxCategoryData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/TaxCategory/CreateTaxCategory?UserName=${userId}`,
      taxCategoryData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving tax category!";
  }
};
